export enum ComplianceTasksTableAction {
  Assign = 'assign',
  AssignWorkshop = 'assignWorkshop',
  Archive = 'archive',
  Restore = 'restore',
  History = 'history',
  EditRequirements = 'editRequirements',
  EditFrequency = 'editFrequency',
  Edit = 'edit',
  Reschedule = 'reschedule',
  ReschedulePre = 'reschedulePre',
  ReschedulePost = 'reschedulePost',
  Delete = 'delete',
  EditDocument = 'editDocument',
  DeleteDocument = 'deleteDocument'
}